import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <nav className="nav-menu">
          <div className="nav-content">
            <img
              src="/icons/logo.svg"
              alt="Nestia Logo"
              className="header-logo"
            />
            <div className="nav-links">
              <a href="#about" className="nav-link">
                à propos
              </a>
              <a href="#partners" className="nav-link">
                Partenaires
              </a>
              <a href="#services" className="nav-link">
                Services
              </a>
              <a href="#process" className="nav-link">
                Process
              </a>
            </div>
            <button className="burger-menu" onClick={toggleSidebar}>
              <span
                className={`burger-line ${isSidebarOpen ? "active" : ""}`}
              ></span>
              <span
                className={`burger-line ${isSidebarOpen ? "active" : ""}`}
              ></span>
              <span
                className={`burger-line ${isSidebarOpen ? "active" : ""}`}
              ></span>
            </button>
          </div>
        </nav>

        {/* Mobile Sidebar */}
        <div
          className={`sidebar-overlay ${isSidebarOpen ? "active" : ""}`}
          onClick={closeSidebar}
        ></div>
        <div className={`sidebar ${isSidebarOpen ? "active" : ""}`}>
          <div className="sidebar-header">
            <img
              src="/icons/logo.svg"
              alt="Nestia Logo"
              className="sidebar-logo"
            />
            <button className="sidebar-close" onClick={closeSidebar}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div className="sidebar-links">
            <a href="#about" className="sidebar-link" onClick={closeSidebar}>
              à propos
            </a>
            <a href="#partners" className="sidebar-link" onClick={closeSidebar}>
              Partenaires
            </a>
            <a href="#services" className="sidebar-link" onClick={closeSidebar}>
              Services
            </a>
            <a href="#process" className="sidebar-link" onClick={closeSidebar}>
              Process
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
